import React from 'react';
import PropTypes from 'prop-types';

const Card = (props) => {
    const { className, content, children, isLoading, id } = props;

    return (
        <div id={id} className={`kbe-card ${className} ${isLoading ? 'kbe-card-loading' : ''}`}>
            {content || children}
        </div>
    );
};

Card.defaultProps = {
    className : '',
    content   : null,
    children  : null,
    id: null,
};

Card.propTypes = {
    className : PropTypes.string,
    content   : PropTypes.oneOfType([ PropTypes.string, PropTypes.node ]),
    children  : PropTypes.oneOfType([ PropTypes.string, PropTypes.node ]),
    id: PropTypes.string,
    isLoading : PropTypes.bool.isRequired,
};

export default Card;
